import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import config from 'react-global-configuration';
import ApiAutocomplete from '../ApiAutocomplete';
import WysiwygField from '../WysiwygField';

import './style.scss';

const TYPE_LOCATION = 'location';

const AutoComplete = ({ callback, label, isCta, defaultValue, onEnterTakeFirstResult = false, locationsData }) => {
  const API_URL = config.get('API_URL');
  const { t } = useTranslation();
  const [item, setItem] = useState(null);

  const submit = useCallback(() => {
    if (item) {
      callback(item);
    }
  }, [callback, item]);

  useEffect(() => {
    submit();
  }, [item]);

  return (
    <div className="Autocomplete__holder">
      <label htmlFor="locationSearch">{t(label)}</label>

      <div className={`Autocomplete__holder__inner ${isCta ? 'cta' : ''}`}>
        <ApiAutocomplete
          id="locationSearch"
          locationsData={locationsData}
          defaultValue={defaultValue}
          endpoint={`${API_URL}/api/autocomplete`}
          placeholder={t('filters.search_bounds.placeholder')}
          onSelectItem={(selectedItem) => {
            if (selectedItem.lat && selectedItem.lon) {
              setItem(selectedItem);
            }
          }}
          renderItem={(selectedItem, active) => {
            return (
              <div className={active ? 'active' : ''}>
                <WysiwygField
                  className="Autocomplete__holder__inner__item"
                  property="schema:text"
                  html={selectedItem.name}
                />
                {selectedItem.type === TYPE_LOCATION && (
                  <span> (Locatie)</span>
                )}
                {(selectedItem.duplicate && selectedItem.gemeente) && (
                  <span> ({selectedItem.gemeente})</span>
                )}
              </div>
            );
          }}
          onEnterTakeFirstResult={onEnterTakeFirstResult}
          isCta={isCta}
          submitHandle={submit}
        />
      </div>
    </div>
  );
};

AutoComplete.defaultProps = {
  isCta: false,
  label: 'filters.search_bounds.label',
};


export default AutoComplete;
